import { createSlice } from "@reduxjs/toolkit"

export const clientSlice = createSlice({
    name: 'clientData',
    initialState: { data: '' },
    reducers: {
        setRowData: (state, action) => {
            state.data = action.payload
        }
    }
})

export const { setRowData } = clientSlice.actions

export default clientSlice.reducer